/**
 * @description エラーハンドリングクラス
 * @module js-error-reporter
 */
class ErrorReporter {
  /**
   * @description istyle共通エラーサーバにエラー内容を送信
   * @param {string} message - エラーメッセージ
   * @param {Error}  error   - エラーオブジェクト
   * @param {string} source  - エラーの発生したファイル
   * @param {number} lineNo  - エラーの発生した行数
   * @param {number} colNo   - エラーの発生した場所が行頭から何文字目か
   * @link https://github.com/istyle-inc/design_common/blob/master/js/error-reporter.js
   */
  report(message, error, source, lineNo = null, colNo = null) {
    this._reportCompat(message, source, lineNo, colNo, error);
  }

  /**
   * @description istyle共通エラーサーバにエラー内容を送信
   *              window.onerror互換インターフェイス
   * @access private
   * @param {string} message - エラーメッセージ
   * @param {string} source  - エラーの発生したファイル
   * @param {number} lineNo  - エラーの発生した行数
   * @param {number} colNo   - エラーの発生した場所が行頭から何文字目か
   * @param {Error}  error   - エラーオブジェクト
   * @link https://github.com/istyle-inc/design_common/blob/master/js/error-reporter.js
   */
  _reportCompat(message, source, lineNo, colNo, error) {
    if (process.env.NODE_ENV !== 'production') {
      console.log(message, error);
    }
    const beacon = new Image();
    beacon.src = this._makeUrl(message, source, lineNo, colNo, error);
  }

  /**
   * @description ビーコンURLの生成
   * @access private
   * @param {string} message - エラーメッセージ
   * @param {string} source  - エラーの発生したファイル
   * @param {number} lineNo  - エラーの発生した行数
   * @param {number} colNo   - エラーの発生した場所が行頭から何文字目か
   * @param {Error}  error   - エラーオブジェクト
   */
  _makeUrl(message, source, lineNo, colNo, error) {
    return '//beacon.cosme.net/js-err'
      + '?m=' + encodeURIComponent(message)
      + '&s=' + encodeURIComponent(source)
      + '&l=' + encodeURIComponent(lineNo)
      + '&c=' + encodeURIComponent(colNo)
      + '&e=' + (error ? encodeURIComponent(error.toString()) : undefined)
      + '&t=' + (error ? encodeURIComponent(error.stack)      : undefined)
      + '&u=' + (new Date().getTime());
  }
}

if (typeof window !== 'undefined' && window && !window.onerror) {
  const errorReporter = new ErrorReporter();
  window.onerror = errorReporter._reportCompat.bind(errorReporter);
}

export default ErrorReporter;
